module.exports = __webpack_public_path__ + "static/img/icon_fb.4f4ff7dc.svg";